import { Injectable } from '@angular/core';

const HOST_MAP: Record<string, string> = {
  local: 'meeting-analysis-api.vendasta-local.com',
  demo: 'meeting-analysis-demo.apigateway.co',
  prod: 'meeting-analysis-prod.apigateway.co',
  production: 'meeting-analysis-prod.apigateway.co',
};

@Injectable({ providedIn: 'root' })
export class TranscriptService {
  private readonly host: string;

  constructor() {
    const env = ((window as any)['environment'] ?? 'prod').toLowerCase();
    this.host = HOST_MAP[env] || HOST_MAP['prod'];
  }

  getTranscriptUrl(conversationId: string): string {
    return `https://${this.host}/rawTranscript/${conversationId}/download`;
  }
}
